import { useSelector, useDispatch } from "react-redux";
import { ColumnDropdown } from "../../../components/Dropdownn";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toster } from "../../../components/Toster/Toster";
import { DateBox, LoadPanel, Popup } from "devextreme-react";
import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import { Table2 } from "../../../components/Table2/Table2";
import { Tablecoloum } from "./Data";
import { CloseoutWizardFunction } from "./CloseoutWizardFunction";
import { paddingBottomIcon } from "@progress/kendo-svg-icons";
import "./CloseoutWizard.css";
import { removeDynamicTab } from "../../../reducer/HomePageReducer";
import { getDateBoxFormat } from "../../Dateapi/dateFormatter";
import { useScreenPermission } from "../../../hooks/useScreenPermission";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
      />
    </>
  );
};

const CloseoutWizard = () => {
  const { closeoutWizardInfo } = useSelector((store) => store.participate);
  const ApiClass = new CloseoutWizardFunction();
  const [loading, setLoading] = useState(false);
  const [approvedbydropdown, setapprovedbydropdown] = useState([]);
  const [viewAccess, setViewAccess] = useState(true);
  const [headerdata, setheaderdata] = useState([]);
  const [gridrows, setgridrows] = useState([]);
  const [closestatuses, setclosestatuses] = useState([]);
  const [approverlist, setapproverlist] = useState([]);
  const [programendreason, setprogramendreason] = useState([]);
  const [fields, setfields] = useState({
    notes: "",
    toBeApprovedBy: {
      id: "00000000-0000-0000-0000-000000000000",
      name: "",
    },
    effectiveDate: new Date(),
    programEndReason: {
      id: "00000000-0000-0000-0000-000000000000",
      name: "",
    },
    closeStatuses: {
      id: "00000000-0000-0000-0000-000000000000",
      name: "",
    },
    writeOff: 0,
    adjustments: 0,
    balance: 0,
    programsToBeClosed: 0,
    cswToBeWrittenOff: 0,
    jailTimeToBeWrittenOff: 0,
  });
  const navigate = useNavigate();
  const SCREEN_NAME = "PS6";
  const { permission, permissionLoading } = useScreenPermission(SCREEN_NAME, navigate);

  const actionDropdown = [
    { name: "-select-", id: "-select-" },
    { name: "Close", id: "Close" },
    { name: "Write Off", id: "Write Off" },
    { name: "Expunge", id: "Expunge" },
    { name: "Waive", id: "Waive" },
    { name: "Exempt", id: "Exempt" },
  ];

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  // const [isValid, setIsValid] = useState(true);
  // console.log("gridrows", gridrows)
  const [errorPopup, setErrorPopup] = useState({
    isVisible: false,
    message: "",
  });
  const dispatch = useDispatch();
  const { id } = useParams();

  const handleClose = () => {
    const offenderNumber = headerdata?.[0]?.sOffenderNumber;

    if (!offenderNumber) {
      console.error("Offender number is unavailable.");
      return;
    }

    dispatch(removeDynamicTab("/closeoutwizard"));
    navigate(`/participant/${offenderNumber}`);
  };

  const handleSubmit = () => {
    if (!fields?.closeStatuses?.id || fields?.closeStatuses?.id === "00000000-0000-0000-0000-000000000000") {
      setToastConfig({
        isVisible: true,
        message: "Please select a Close Status",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1900);

      return;
    }

    if (!fields?.toBeApprovedBy?.id || fields?.toBeApprovedBy?.id === "00000000-0000-0000-0000-000000000000") {
      setToastConfig({
        isVisible: true,
        message: "Please select an Approver",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1900);

      return;
    }

    const invalidActionRow = gridrows?.find(
      (item) => Number(item.Balance || 0) > 0 && (!item.Action || item.Action === "-select-"),
    );

    if (invalidActionRow) {
      setToastConfig({
        isVisible: true,
        message: `Please select an action for ${invalidActionRow["Fee Name"]}`,
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1900);

      return;
    }

    const data = {
      gPersonID: closeoutWizardInfo.gPersonId,
      closeStatusesID: fields?.closeStatuses?.id,
      toBeApprovedBy: fields?.toBeApprovedBy?.id,
      effectiveDate: fields?.effectiveDate,
      notes: fields?.notes,

      programEndReasonID:
        fields?.programEndReason?.id === "00000000-0000-0000-0000-000000000000" ? null : fields?.programEndReason?.id,

      gridData: gridrows?.map((item) => ({
        sCourtName: item.Court,
        sDocketNumberCourtCounts: item["Docket/Count"],
        sFeeCode: item["Fee Code"],
        sFeeName: item["Fee Name"],
        fAmount: item.Amount,
        fBalance: item.Balance,

        action: Number(item.Balance || 0) === 0 ? "Close" : item.Action,

        adjustmentAmount: Number(item.Balance || 0) === 0 ? 0 : item["Adjustment Amount"],

        gObligationID: item.gObligationID,
        bFinancialStatusActive: item.bFinancialStatusActive,
        sFeeScheduleType: item.sFeeScheduleType,
        sFinancialStatusName: item.sFinancialStatusName,
      })),
    };

    ApiClass.submitCloseoutWizardData(navigate, setLoading, setToastConfig, toastConfig, data, handleClose);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setfields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // const handleSplitRow=(rowData)=>{
  //     if(!rowData) return;
  //     const newRow={
  //         ...rowData,
  //         ID: Date.now(),
  //         "Fee Name":rowData["Fee Name"] + "(split)",
  //     };
  //     const updatedRows = [...gridrows, newRow];
  //     // setgridrows(updatedRows);
  // }

  const handleSplitRow = (rowData) => {
    if (!rowData) return;

    const newRow = {
      ...rowData,
      ID: Date.now(), // Assign a unique ID
      "Fee Name": rowData["Fee Name"] + " (split)",
    };

    // setgridrows((prev) => [...prev, newRow]);
    const updatedRows = [...gridrows, newRow];
    setgridrows(updatedRows);
    recalculateSummaryFields(updatedRows);
  };
  // const handleCellValueChanged = (e) => {
  //     const writeOffTotal = (gridrows
  //         .filter((item) => item.Action === "WriteOff")
  //         .reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)).toFixed(2);

  //     const waiveExemptTotal = (gridrows
  //         .filter((item) => item.Action === "Waive" || item.Action === "Exempt")
  //         .reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)).toFixed(2);

  //     const balanceAdjustmentDiff =
  //         (gridrows.reduce((sum, item) => sum + (item.Balance || 0), 0) -
  //             gridrows.reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)).toFixed(2);

  //     setfields((prevFields) => ({
  //         ...prevFields,
  //         writeOff: writeOffTotal,
  //         adjustments: waiveExemptTotal,
  //         balance: balanceAdjustmentDiff
  //     }));
  // }

  const recalculateSummaryFields = (rows = gridrows) => {
    const writeOffTotal = rows
      .filter((item) => item.Action === "Write Off")
      .reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)
      .toFixed(2);

    const waiveExemptTotal = rows
      .filter((item) => item.Action === "Waive" || item.Action === "Exempt")
      .reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)
      .toFixed(2);

    const balanceAdjustmentDiff = (
      rows.reduce((sum, item) => sum + (item.Balance || 0), 0) -
      rows.reduce((sum, item) => sum + (item["Adjustment Amount"] || 0), 0)
    ).toFixed(2);

    setfields((prevFields) => ({
      ...prevFields,
      writeOff: writeOffTotal,
      adjustments: waiveExemptTotal,
      balance: balanceAdjustmentDiff,
    }));
  };

  const handleCellValueChanged = () => {
    recalculateSummaryFields();
  };

  useEffect(() => {
    if (!headerdata?.length) return;

    setfields((prevFields) => ({
      ...prevFields,
      notes: headerdata[0]?.sNote || "",
      effectiveDate: headerdata[0]?.dEffective ? new Date(headerdata[0].dEffective) : new Date(),
    }));
  }, [headerdata]);

  useEffect(() => {
    ApiClass.loadCloseoutWizardData(
      navigate,
      setLoading,
      setheaderdata,
      setgridrows,
      setclosestatuses,
      setapproverlist,
      setprogramendreason,
      closeoutWizardInfo.gPersonId,
      setToastConfig,
      setViewAccess,
      setErrorPopup,
    );
    // ApiClass.approvedByDropdown(navigate, setLoading, setapprovedbydropdown);
  }, []);

  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Popup
        onHiding={() => {}}
        showTitle={false}
        width={1180}
        height={860}
        showCloseButton={true}
        hideOnOutsideClick={false}
      ></Popup>

      <div className="particcipentPage">
        <DynamicTabb />
        <Popup
          visible={errorPopup.isVisible}
          onHiding={() => {
            setErrorPopup({ isVisible: false, message: "" });
            dispatch(removeDynamicTab("/closeoutwizard"));
            navigate(`/participant/${headerdata[0].sOffenderNumber}`);
          }}
          showTitle={true}
          showCloseButton={true}
          width={500}
          height={200}
        >
          <div style={{ padding: "20px", fontSize: "16px", textAlign: "center" }}>{errorPopup.message}</div>
        </Popup>
        {permissionLoading ? (
          <LoadPanel shadingColor="true" visible={true} delay={10} />
        ) : !permission.view ? (
          <div style={{ padding: "20px", fontWeight: 600 }}>
            You do not have View access for PS.6. Please contact your system administrator.
          </div>
        ) : (
          <div>
            <div
              className="screen_num"
              style={{
                marginTop: ".5%",
                marginLeft: ".5%",
                marginRight: ".5%",
              }}
            >
              <p>PS.6</p>
            </div>
            <div className="RecivePaymentModell_block1">
              <div style={{ flexGrow: "1" }}>
                <div className="RecivePaymentModell_block1_sub">
                  <div className="display-flex-div ">
                    <label className="inner_width  ">Offender Number </label>
                    <div id="Query">
                      {headerdata && headerdata.length > 0 && headerdata[0].sOffenderNumber
                        ? headerdata[0].sOffenderNumber
                        : ""}
                    </div>
                  </div>
                  <div id="Query">
                    {headerdata && headerdata.length > 0 && headerdata[0].sLastFirst ? headerdata[0].sLastFirst : ""}
                  </div>
                </div>
                <div className="RecivePaymentModell_block1_sub">
                  <div className="display-flex-div">
                    <label className="inner_width  ">Active Dockets</label>{" "}
                    <div id="Query">
                      {headerdata && headerdata.length > 0 && headerdata[0].iActiveDocketCourt
                        ? headerdata[0].iActiveDocketCourt
                        : ""}
                    </div>
                  </div>
                  <div className="display-flex-div ">
                    <label className="inner_width  ">Dockets </label>
                    <div id="Query">
                      {" "}
                      {headerdata && headerdata.length > 0 && headerdata[0].sDocketNumberCourtCounts
                        ? headerdata[0].sDocketNumberCourtCounts
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="RecivePaymentModell_block1_sub"></div>
              </div>
            </div>
            <div style={{ marginLeft: "1.5%" }}>
              <Table2
                editTable={false}
                Tablecoloum={Tablecoloum}
                tableRow={gridrows}
                load={loading}
                coloumWidthText={"CloseoutWizardTableWidth"}
                mandatoryColoum={"Docket/Count"}
                showTotalBlock={true}
                editableParticularValue={true}
                actionDropdown={actionDropdown}
                handleCellValueChanged={handleCellValueChanged}
                handleSplitRow={handleSplitRow}

                // onValidate={handleValidation}
              />
            </div>

            <div style={{ display: "flex", gap: "2%", alignItems: "flex-start" }}>
              <div
                style={{
                  display: "flex",
                  // width: "45%",
                  flexDirection: "column",
                }}
              >
                <div className="display-flex-div set-height">
                  <label className="edit_container_label" style={{}}>
                    Close Statuses
                  </label>
                  <div style={{ marginLeft: "2%", width: "284px" }}>
                    <DropDown
                      setfields={setfields}
                      width="350px"
                      fields={fields}
                      fieldNmae={"closeStatuses"}
                      dropDownData={closestatuses?.map((val) => {
                        return {
                          name: val?.sName,
                          id: val?.gSupervisionStatusID,
                        };
                      })}
                    />
                  </div>
                </div>
                <div className="display-flex-div">
                  <label className="edit_container_label  ">Effective Date</label>
                  <DateBox
                    displayFormat={getDateBoxFormat()}
                    style={{ marginLeft: "2%" }}
                    useMaskBehavior={true}
                    type="date"
                    value={fields.effectiveDate}
                    onValueChange={(value) => {
                      setfields((prevFields) => ({
                        ...prevFields,
                        effectiveDate: value,
                      }));
                    }}
                  />
                  <label className="edit_container_label">Valid Dates</label>
                  <div id="Query">
                    {headerdata && headerdata.length > 0 && headerdata[0].sCloseDates ? headerdata[0].sCloseDates : ""}
                  </div>
                </div>

                <div className="display-flex-div set-height">
                  <label className="edit_container_label">Close-Out Notes </label>
                  <textarea
                    value={fields.notes}
                    style={{
                      marginTop: "4%",
                      height: "80px",
                    }}
                    name="notes"
                    id="notes"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/* second */}
              {/* <div style={{
                                display: 'flex',
                                width: "55%",
                                flexDirection: 'column',
                                // paddingBottom: '30px'
                                justifyContent: 'flex-start',
                            }}>
                                <div className="display-flex-div set-height" >
                                    <label className="edit_container_label">Obligation Adjustments</label>
                                    <div id="Query">
                                        ${fields.adjustments}
                                    </div>
                                </div>
                                <div className="display-flex-div set-height">
                                    <label className="edit_container_label">Obligation Write Offs </label>
                                    <div id="Query">
                                        ${fields.writeOff}
                                    </div>
                                </div>
                                <div className="display-flex-div set-height">
                                    <label className="edit_container_label">Remaining Balance</label>
                                    <div id="Query">
                                        ${fields.balance}
                                    </div>
                                </div>
                                <div className="display-flex-div set-height">
                                    <label className="edit_container_label" style={{}}>To Be Approved By</label>
                                    <DropDown
                                        setfields={setfields}
                                        width="350px"
                                        fields={fields}
                                        fieldNmae={"toBeApprovedBy"}
                                        dropDownData={approverlist?.map((val) => {
                                            return {
                                                name: val?.sLastFirst,
                                                id: val?.gUserID,
                                            };
                                        })}
                                        value={approverlist && approverlist.length > 0 && approverlist[0].sLastFirst}
                                    />

                                </div>
                            </div> */}
              <div
                style={{
                  display: "flex",
                  // width: "55%",
                  width: "620px",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Obligation Adjustments
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    ${fields.adjustments}
                  </div>
                </div>

                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Obligation Write Offs
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    ${fields.writeOff}
                  </div>
                </div>

                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Remaining Balance
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    ${fields.balance}
                  </div>
                </div>
                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Programs to Close
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    {headerdata?.[0]?.iProgramsToBeClosed ?? ""}
                    {/* {fields.programsToBeClosed} */}
                  </div>
                </div>
                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Close Reason
                  </label>
                  <div style={{ width: "50%" }}>
                    <DropDown
                      setfields={setfields}
                      width="100%"
                      fields={fields}
                      fieldNmae={"programEndReason"}
                      dropDownData={programendreason?.map((val) => ({
                        name: val?.sName,
                        id: val?.gProgramEndReasonID,
                      }))}
                      value={fields.programEndReason?.name}
                    />
                  </div>
                </div>
                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    CSW to be Written Off
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    {headerdata?.[0]?.fCswToBeWrittenOff ?? ""}
                  </div>
                </div>
                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    Jail Time to be Written Off
                  </label>
                  <div id="Query" style={{ width: "50%" }}>
                    {headerdata?.[0]?.iJailTimeToBeWrittenOff ?? ""}
                  </div>
                </div>

                <div className="display-flex-div set-height" style={{ alignItems: "center" }}>
                  <label
                    className="edit_container_label"
                    style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                  >
                    To Be Approved By
                  </label>
                  <div style={{ width: "50%" }}>
                    <DropDown
                      setfields={setfields}
                      width="100%"
                      fields={fields}
                      fieldNmae={"toBeApprovedBy"}
                      dropDownData={approverlist?.map((val) => ({
                        name: val?.sLastFirst,
                        id: val?.gUserID,
                      }))}
                      value={approverlist && approverlist.length > 0 && approverlist[0].sLastFirst}
                    />
                  </div>
                </div>
              </div>

              {/* <div style={{ width: "55%" }}>
                                {[
                                    { label: "Obligation Adjustments", value: `$${fields.adjustments}` },
                                    { label: "Obligation Write Offs", value: `$${fields.writeOff}` },
                                    { label: "Remaining Balance", value: `$${fields.balance}` },
                                ].map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginBottom: "10px",
                                            width: "100%",
                                        }}
                                    >
                                        <label
                                            className="edit_container_label"
                                            style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                                        >
                                            {item.label}
                                        </label>
                                        <div style={{ width: "50%" }} id="Query">
                                            {item.value}
                                        </div>
                                    </div>
                                ))}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <label
                                        className="edit_container_label"
                                        style={{ width: "50%", textAlign: "right", paddingRight: "10px" }}
                                    >
                                        To Be Approved By
                                    </label>
                                    <div style={{ width: "50%" }}>
                                        <DropDown
                                            setfields={setfields}
                                            width="100%"
                                            fields={fields}
                                            fieldNmae={"toBeApprovedBy"}
                                            dropDownData={approverlist?.map((val) => ({
                                                name: val?.sLastFirst,
                                                id: val?.gUserID,
                                            }))}
                                        />
                                    </div>
                                </div>
                            </div> */}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "30%",
              }}
            >
              <button className="btn primary_btn" onClick={handleSubmit}>
                Submit
              </button>
              <button className="btn primary_btn" style={{ marginLeft: "10px" }} onClick={handleClose}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CloseoutWizard;
